export const SINGLE_BLOG_LOADER = "SINGLE_BLOG_LOADER";
export const SINGLE_BLOG_SUCCESS = "SINGLE_BLOG_SUCCESS";
export const SINGLE_BLOG_FAILURE = "SINGLE_BLOG_FAILURE";
export const SINGLE_BLOG_RESET = "SINGLE_BLOG_RESET";
